import {
  ButtonHTMLAttributes,
  DetailedHTMLProps,
  ReactNode,
  forwardRef,
} from "react";
import {
  LABEL_COLOR,
  LABEL_SIZE,
  LABEL_STYLE,
  LABEL_TYPE,
} from "@shared/components/label/label";
import { useLabelStyles } from "./useLabelStyle";

type ButtonProps = DetailedHTMLProps<
  ButtonHTMLAttributes<HTMLButtonElement>,
  HTMLButtonElement
>;
interface Props extends Omit<ButtonProps, "color" | "type" | "style"> {
  type?: LABEL_TYPE;
  size?: LABEL_SIZE;
  color: LABEL_COLOR;
  style: LABEL_STYLE;
  className?: string;
  startIcon?: ReactNode;
  endIcon?: ReactNode;
}

const Label = forwardRef<HTMLButtonElement, Props>(
  (
    {
      type = LABEL_TYPE.SQUARE,
      size = LABEL_SIZE.MEDIUM,
      color = LABEL_COLOR.DEFAULT,
      style = LABEL_STYLE.FILL,
      className,
      children,
      startIcon,
      endIcon,
      ...otherProps
    },
    ref
  ) => {
    const { className: computedClassName } = useLabelStyles({
      size,
      type,
      color,
      style,
      className,
    });
    return (
      <button ref={ref} className={computedClassName} {...otherProps}>
        {startIcon}
        {children}
        {endIcon}
      </button>
    );
  }
);

export default Label;
